import { get } from 'lodash';
import { Storage } from '../../../utils/storage';

const Auth = require('j-toker');

export const clearAuth = () => {
  Storage.clearAll();
};

Auth.configure({
  apiUrl: process.env.REACT_APP_API_URL,
  signOutPath: `${process.env.REACT_APP_API_URL}/sign_out`,
  // emailSignInPath: `${process.env.REACT_APP_API_URL}/sign_in`,
  emailRegistrationPath: '/registration',
  accountUpdatePath: '/update',
  accountDeletePath: '/delete',
  passwordResetPath: '/reset_password',
  passwordUpdatePath: '/update_password',
  tokenValidationPath: '/auth/validate_token',

  proxyIf() {
    return false;
  },

  proxyUrl: '/proxy',
  validateOnPageLoad: false,
  forceHardRedirect: false,
  storage: 'localStorage',
  cookieExpiry: 14,
  cookiePath: '/',

  passwordResetSuccessUrl() {
    return window.location.href;
  },

  confirmationSuccessUrl() {
    return window.location.href;
  },

  tokenFormat: {
    'access-token': 'access-token',
    'token-type': 'Bearer',
    client: 'client',
    expiry: 'expiry',
    uid: 'uid',
  },

  parseExpiry(headers) {
    // convert from ruby time (seconds) to js time (millis)
    return parseInt(headers.expiry, 10) * 1000 || null;
  },

  handleLoginResponse(resp) {
    return resp.data;
  },

  handleAccountUpdateResponse(resp) {
    return resp.data;
  },

  handleTokenValidationResponse(resp) {
    return resp.data;
  },

  authProviderPaths: {
    github: '/github',
    facebook: '/facebook',
    google: '/google_oauth2',
  },
});

export const setAuth = data => {
  Storage.setData('currentUser', data.user);
  Storage.setData('isLoggedIn', get(data, 'data.signedIn', true));
};

export const setHeaders = headers => {
  Storage.setData('authHeaders', headers);
};
